import { render } from "./ReferencesPage.vue?vue&type=template&id=555e0d84&scoped=true"
import script from "./ReferencesPage.vue?vue&type=script&lang=js"
export * from "./ReferencesPage.vue?vue&type=script&lang=js"

import "./ReferencesPage.vue?vue&type=style&index=0&id=555e0d84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555e0d84"]])

export default __exports__